export const supportPage = "/support";
